var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-content',[_c('router-view')],1),_c('v-footer',{attrs:{"fixed":_vm.fixed,"app":""}},[_c('v-spacer'),_c('span',[_vm._v("© 2017")]),_c('v-spacer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }